export default [
  {
    path: '/e-channels/cards/card-profile',
    name: 'card-profiles',
    component: () => import('@/views/pages/e-channels/cards/CardProfiles.vue'),
    meta: {
      pageTitle: 'Card Profiles',
      hasPermission: 'VIEW_CARD_PROFILE',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Cards',
        },
        {
          text: 'Card Profiles',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/cards/card-request-log',
    name: 'card-request-log',
    component: () => import('@/views/pages/e-channels/cards/CardRequestLog.vue'),
    meta: {
      pageTitle: 'Request Log From Web / Mobile',
      hasPermission: 'VIEW_CARD_REQUEST_LOG',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Cards',
        },
        {
          text: 'Request Log From Web / Mobile',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/cards/batch-cards-request-list',
    name: 'batch-cards-request-list',
    component: () => import('@/views/pages/e-channels/cards/BatchCardsRequest/Index.vue'),
    meta: {
      pageTitle: 'Batch Cards Request',
      hasPermission: 'VIEW_CARD_REQUESTS',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Cards',
        },
        {
          text: 'Batch Cards Request',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/cards/batch-cards-request',
    name: 'batch-cards-request',
    component: () => import('@/views/pages/e-channels/cards/BatchCardsRequest/BatchCardsRequest.vue'),
    meta: {
      pageTitle: 'Batch Cards Request',
      hasPermission: 'VIEW_CARD_REQUESTS',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Cards',
        },
        {
          text: 'Batch Cards Request',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/cards/host-financial-institutions',
    name: 'host-financial-institutions',
    component: () => import('@/views/pages/e-channels/cards/HostFinancialInstitution.vue'),
    meta: {
      pageTitle: 'Host Financial Institution',
      hasPermission: 'VIEW_HOST_FINANCIAL_INSTITUTION',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Cards',
        },
        {
          text: 'Host Financial Institution',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/cards/issue-card-list',
    name: 'issue-card-list',
    component: () => import('@/views/pages/e-channels/cards/ManageCards/Index.vue'),
    meta: {
      pageTitle: 'Issue Card',
      hasPermission: 'MANAGE_CARDS',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Cards',
        },
        {
          text: 'Issue Card',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/cards/issue-card',
    name: 'issue-card',
    component: () => import('@/views/pages/e-channels/cards/ManageCards/IssueCards.vue'),
    meta: {
      pageTitle: 'Issue Card',
      hasPermission: 'VIEW_ISSUED_CARDS',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Cards',
        },
        {
          text: 'Issue Card',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/cards/providus-issue-card-list',
    name: 'providus-issue-card-list',
    component: () => import('@/views/pages/e-channels/cards/ManageCards/ProvidusIssueCardList.vue'),
    meta: {
      pageTitle: 'Issue Card(Providus)',
      hasPermission: 'MANAGE_CARDS',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Cards',
        },
        {
          text: 'Issue Card(Providus)',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/cards/providus-issue-card',
    name: 'providus-issue-card',
    component: () => import('@/views/pages/e-channels/cards/ManageCards/IssueCardsProvidus.vue'),
    meta: {
      pageTitle: 'Issue Card(Providus)',
      hasPermission: 'VIEW_ISSUED_CARDS',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Cards',
        },
        {
          text: 'Issue Card(Providus)',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/cards/route-config',
    name: 'route-config',
    component: () => import('@/views/pages/e-channels/cards/RouteConfig.vue'),
    meta: {
      pageTitle: 'Route Config',
      hasPermission: 'VIEW_CARD_CONFIG',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Cards',
        },
        {
          text: 'Route Configuration',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/cards/manage-cards',
    name: 'manage-cards',
    component: () => import('@/views/pages/e-channels/cards/ManageCards/ManageCards.vue'),
    meta: {
      pageTitle: 'Manage Cards',
      hasPermission: 'MANAGE_CARDS',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Cards',
        },
        {
          text: 'Manage Cards',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/cards/iso-card-report',
    name: 'iso-card-report',
    component: () => import('@/views/pages/e-channels/cards/TransactionReports/ISOCardReport.vue'),
    meta: {
      pageTitle: 'ISO Card Transaction Report',
      hasPermission: 'VIEW_ISSUED_CARDS',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Cards',
        },
        {
          text: 'ISO Card Transaction Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/cards/card-report',
    name: 'card-report',
    component: () => import('@/views/pages/e-channels/cards/TransactionReports/CardReport.vue'),
    meta: {
      pageTitle: 'Card Transaction Report',
      hasPermission: 'VIEW_ISSUED_CARDS',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Cards',
        },
        {
          text: 'Card Transaction Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/transfers/interbank-configurations',
    name: 'interbank-configurations',
    component: () => import('@/views/pages/e-channels/transfers/configurations/Index.vue'),
    meta: {
      pageTitle: 'Configurations',
      hasPermission: 'VIEW_INTERBANK_TRANSFER_CONFIGURATION',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Interbank Transfer',
        },
        {
          text: 'Configurations',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/transfers/outward-transfers',
    name: 'outward-transfers',
    component: () => import('@/views/pages/e-channels/transfers/OutwardTransfers/Index.vue'),
    meta: {
      pageTitle: 'Outward Transfers',
      hasPermission: 'VIEW_TRANSFER_REPORT',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Interbank Transfer',
        },
        {
          text: 'Outward Transfers',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/transfers/initiate-outward-transfer',
    name: 'initiate-outward-transfer',
    component: () => import('@/views/pages/e-channels/transfers/OutwardTransfers/OutwardTransfers.vue'),
    meta: {
      pageTitle: 'Outward Transfers',
      hasPermission: 'INITIATE_TRANSFER',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Interbank Transfer',
        },
        {
          text: 'Outward Transfers',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/transfers/inward-transfers',
    name: 'inward-transfers',
    component: () => import('@/views/pages/e-channels/transfers/InwardTransfers/InwardTransfers.vue'),
    meta: {
      pageTitle: 'Inward Transfers',
      hasPermission: 'VIEW_INWARD_TRANSFER_REPORT',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Interbank Transfer',
        },
        {
          text: 'Inward Transfers',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/internet-banking/enrolled-customer-profile',
    name: 'enrolled-customer-profile',
    component: () => import('@/views/pages/e-channels/internet-banking/EnrolledCustomerProfile.vue'),
    meta: {
      pageTitle: 'Enrolled Customer Profile',
      hasPermission: 'VIEW_INTERNET_BANKING_USERS',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Internet Banking',
        },
        {
          text: 'Enrolled Customer Profile',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/internet-banking/enroll-corporate-profile',
    name: 'enroll-corporate-profile',
    component: () => import('@/views/pages/e-channels/internet-banking/EnrollCorporateProfile.vue'),
    meta: {
      pageTitle: 'Enroll Corporate Profile',
      hasPermission: 'VIEW_CORPORATE_INTERNET_USERS',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Internet Banking',
        },
        {
          text: 'Enroll Corporate Profile',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/internet-banking/add-corporate-profile',
    name: 'add-corporate-profile',
    component: () => import('@/views/pages/e-channels/internet-banking/AddCorporateProfile.vue'),
    meta: {
      pageTitle: 'Add Corporate Profile',
      hasPermission: 'VIEW_INTERNET_BANKING_USERS',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Internet Banking',
        },
        {
          text: 'Add Corporate Profile',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/internet-banking/profile-product-setup/casa-profile-setup',
    name: 'casa-profile-setup',
    component: () => import('@/views/pages/e-channels/internet-banking/profile-product-setup/CASAProfileSetup.vue'),
    meta: {
      pageTitle: 'CASA Profile Setup',
      hasPermission: 'VIEW_IBANKING_CUSTOMER_ONBOARDING_CONFIG',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Internet Banking',
        },
        {
          text: 'CASA Profile Setup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/internet-banking/profile-product-setup/fd-profile-setup',
    name: 'fd-profile-setup',
    component: () => import('@/views/pages/e-channels/internet-banking/profile-product-setup/FDProfileSetup.vue'),
    meta: {
      pageTitle: 'FD Profile Setup',
      hasPermission: 'VIEW_IBANKING_CUSTOMER_ONBOARDING_CONFIG',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Internet Banking',
        },
        {
          text: 'FD Profile Setup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/internet-banking/internet-banking-enrolment',
    name: 'internet-banking-enrolment',
    component: () => import('@/views/pages/e-channels/internet-banking/InternetBankingEnrolment.vue'),
    meta: {
      pageTitle: 'Internet Banking Enrolment',
      hasPermission: 'ONBOARD_IBANKING_USER',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Internet Banking',
        },
        {
          text: 'Internet Banking Enrolment',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/internet-banking/savings-pocket-setup',
    name: 'savings-pocket-setup',
    component: () => import('@/views/pages/e-channels/internet-banking/SavingsPocketSetup.vue'),
    meta: {
      pageTitle: 'Savings Pocket Setup',
      hasPermission: 'VIEW_SAVINGS_POCKET_SETUP',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Internet Banking',
        },
        {
          text: 'Savings Pocket Setup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/internet-banking/theme-setup',
    name: 'theme-setup',
    component: () => import('@/views/pages/e-channels/internet-banking/ThemeSetup.vue'),
    meta: {
      pageTitle: 'Theme Setup',
      hasPermission: 'VIEW_THEME',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Internet Banking',
        },
        {
          text: 'Theme Setup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/internet-banking/accounts-upgrades-request',
    name: 'accounts-upgrades-request',
    component: () => import('@/views/pages/e-channels/internet-banking/AccountUpgradeRequest.vue'),
    meta: {
      pageTitle: 'Accounts Upgrades Request',
      hasPermission: 'VIEW_ACCOUNT_UPGRADE_REQUEST',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Internet Banking',
        },
        {
          text: 'Accounts Upgrades Request',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/internet-banking/configurations',
    name: 'configurations',
    component: () => import('@/views/pages/e-channels/internet-banking/configurations/Index.vue'),
    meta: {
      pageTitle: 'Configurations',
      hasPermission: 'VIEW_SECURITY_CONFIG',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Internet Banking',
        },
        {
          text: 'Configurations',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/bills-payment',
    name: 'bills-payment',
    component: () => import('@/views/pages/e-channels/bills-payment/Index.vue'),
    meta: {
      pageTitle: 'Bills Payment',
      hasPermission: 'VIEW_BILLS_PAYMENT_HISTORY',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Bills Payment',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/initiate-bills-payment',
    name: 'initiate-bills-payment',
    component: () => import('@/views/pages/e-channels/bills-payment/BillsPayment.vue'),
    meta: {
      pageTitle: 'Bills Payment',
      hasPermission: 'VIEW_BILLS_PAYMENT_HISTORY',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Bills Payment',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/bills-configurations',
    name: 'bills-configurations',
    component: () => import('@/views/pages/e-channels/bills-payment/Configurations.vue'),
    meta: {
      pageTitle: 'Bills Payment',
      hasPermission: 'ADD_BILLS_PAYMENT_CONFIG',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Bills Payment',
        },
        {
          text: 'Configurations',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/view-bills-wallet',
    name: 'view-bills-wallet',
    component: () => import('@/views/pages/e-channels/bills-payment/ViewBillsWallet.vue'),
    meta: {
      pageTitle: 'View Bills Wallet',
      hasPermission: 'VIEW_BILLS_WALLET',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'View Bills Wallet',
          active: true,
        },
      ],
    },
  },
  {
    path: '/e-channels/open-api',
    name: 'open-api',
    component: () => import('@/views/pages/e-channels/open-api/OpenAPI.vue'),
    meta: {
      pageTitle: 'Open API',
      hasPermission: 'SEARCH_API_CLIENTS',
      breadcrumb: [
        {
          text: 'E-Channels',
        },
        {
          text: 'Open API',
          active: true,
        },
      ],
    },
  },
]
